export default "__VITE_ASSET__4220c921__"